import React from 'react';
import ReactDOM from 'react-dom';

const Titulo = props => {
    return (<div className="row top-separator-xs">
        <div className="col-xs-12">
            <div className="row bottom-separator">
                <div className="col-xs-12">
                    <h2>
                        {props.titulo}
                    </h2>
                </div>
            </div>
        </div>
    </div>);
};

export default Titulo;